import React, { useState, useRef } from 'react';
import './Escudo.css';

const Escudo = ({ variant = 'default' }) => {
  const defaultSrc = variant === 'footer'
    ? `${process.env.PUBLIC_URL || ''}/images/logo.png`
    : `${process.env.PUBLIC_URL || ''}/images/escudo_letras_nuevo.png`;
  const [imageSrc, setImageSrc] = useState(defaultSrc);
  const errorHandled = useRef(false);
  
  const handleError = (e) => {
    if (errorHandled.current) {
      e.target.style.display = 'none';
      return;
    }
    errorHandled.current = true;
    const fallbackSrc = variant === 'footer'
      ? `${process.env.PUBLIC_URL || ''}/images/escudo_letras_nuevo.png`
      : `${process.env.PUBLIC_URL || ''}/images/logo.png`;
    if (e.target.src !== fallbackSrc) {
      errorHandled.current = false;
      setImageSrc(fallbackSrc);
    } else {
      // Si todos fallan, ocultar sin causar errores
      e.target.style.display = 'none';
    }
  };
  
  return (
    <div className="escudo-container">
      <img
        src={imageSrc}
        alt="Escudo de la Diócesis de Ipiales"
        className="escudo-image"
        onError={handleError}
        onLoad={() => {
          // Si la imagen carga correctamente, asegurar que esté visible
          errorHandled.current = false;
        }}
      />
    </div>
  );
};

export default Escudo;


